"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStatusRouter = void 0;
const config_1 = require("config");
const actions_1 = require("../../../flex-finalize/actions");
const actions_2 = require("../../actions");
const createStatusRouter = (history, dispatch, analytics, path) => {
    return (result) => {
        const { status, adsAcceptedOfferStatus } = result;
        const buildPath = (subPath) => {
            const base = path.endsWith('/') ? path : `${path}/`;
            return `${base}${subPath}`;
        };
        if (status === 'created') {
            history.push(buildPath('landing'));
        }
        else if (status === 'transaction_created') {
            analytics?.track('ApplicationApproved', {});
            dispatch((0, actions_2.setLenderName)(result.consumerCreditInstrument?.lenderName || ''));
            dispatch((0, actions_2.setPersonalInfo)({
                firstName: result.firstName,
                lastName: result.lastName,
            }));
            dispatch((0, actions_2.setApprovedApplication)(result.consumerCreditInstrument));
            dispatch((0, actions_1.setSigningUrl)(result.signingUrl));
            history.push(buildPath('approval'));
        }
        else if (status === 'pending' &&
            adsAcceptedOfferStatus === 'pending_step_up') {
            history.push(config_1.STEP_UP_REQUIRED_URL);
        }
        else if (status === 'pending') {
            history.push(buildPath('pending'));
        }
        else if (status === 'declined') {
            history.push(buildPath('declined'));
        }
    };
};
exports.createStatusRouter = createStatusRouter;
